import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const PropertyBerthingSchema = z.object({
  _id: objectIdSchema,
  name: z.string(),
});
